/**
 * @description
 * 表格排序
 * 1. 表格只支持单列在排序过程中, 这里不设计同时存在多列排序的规则, 因为这种需求本身不合理, 排序只能按照某一个值去做计算
 * 2. 本地排序只支持排序当前分页
 * 3. 排序值取字data[], 如果data item的值是value, 那么我们会对value进行排序, 而不是value映射出的text排序
 */
export interface ITableSort<T> {
  /**
   * @description 是否开启排序
   * @param custom 表示后端排序
   * @param boolean true则开启，false不开启，默认不开启
   */
  readonly sortable?: boolean | 'custom';

  // 注意：
  // 内置排序会根据选中的TableSortAction进行调整, 升序不做处理, 降序则会对排序结果进行reverse
  readonly sorter?: (a: T, b: T) => number;

  // 远程排序, 调用接口
  readonly sortRemote?: (value: ITableSortValue) => Promise<T[]>;
}

// 表格排序值状态
export interface ITableSortValue {
  readonly key: string; // 排序的字段key
  readonly order?: TableSortAction; // 默认升序asc
}

// 排序动作
export enum TableSortAction {
  'ascending' = 'ascending',
  'descending' = 'descending',
}
